// extracted by mini-css-extract-plugin
export default {"root":"RealhubFooter__root--QJ8dT","dark":"RealhubFooter__dark--UjLjQ","logo":"RealhubFooter__logo--omaKo"};